import { Badge, Tooltip } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { dateTime } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import React from "react";

interface FinishBadgeProps {
  at: Date;
  by?: string;
}

const FinishedBadge = ({ at, by }: FinishBadgeProps) => (
  <Tooltip
    label={
      <React.Fragment>
        {by ? (
          <Trans>
            Finished by <b>{by}</b>
          </Trans>
        ) : (
          <Trans>Finished</Trans>
        )}{" "}
        <Trans>on {dateTime.format(at)}</Trans>
      </React.Fragment>
    }
  >
    <Badge colorScheme="green">
      <Trans>Finished</Trans>
    </Badge>
  </Tooltip>
);

export default observer(FinishedBadge);
